export function constructResponse(questions: NOSurveyQuestion[]) {
  return questions.reduce((acc, question) => {
    if (question.selected_answer) {
      acc[question.question_key] = question.selected_answer;
    }
    return acc;
  }, {});
}
